import { render, staticRenderFns } from "./delivery-avatarfleet.vue?vue&type=template&id=473ca87c"
import script from "./delivery-avatarfleet.vue?vue&type=script&lang=js"
export * from "./delivery-avatarfleet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports